<template>
	<div class="container-fluid sign-in-form-container" ref="signInFormContainer" v-cloak>
		<div class="row">

			<!-- login form -->
			<div class="col-12 login-form" v-show="showLoginForm">
				<h2 class="text-center">Login</h2>
				<input type="email" class="input-email form-control" autocomplete="login-email" placeholder="Email" @keypress="loginFormEmailChanged" @keyup.enter="loginIfLoginEnabled" v-model="loginForm.email">
				<input type="password" class="input-password form-control" autocomplete="login-password" placeholder="Password" @keypress="loginFormPasswordChanged" @keyup.enter="loginIfLoginEnabled" v-model="loginForm.password">
				<button type="submit" class="btn btn-primary button-submit" :disabled="disableLoginButton" @click="login">Login</button>
				<div class="cta-links clearfix">
					<span class="span-link reg-link" @click="clickRegisterLink">No Account Yet?</span>
					<a href="/password/" rel="nofollow" target="_blank" class="pw-link">Forgot Password?</a>
				</div>
				<div class="login-form-submission-feedback" v-show="loginSubmissionFeedbackNotNull">
					<span v-html="loginForm.submissionFeedback"></span>
				</div>
			</div>
			<!-- login form -->

			<!-- reg form -->
			<div class="col-12 registration-form" v-show="showRegistrationForm">
				<h2 class="text-center">Register</h2>
				<input type="text" class="input-first-name form-control" autocomplete="reg-first-name" placeholder="First Name" @keypress="regFormFirstNameChanged" @keyup.enter="registerIfRegEnabled" v-model="regForm.firstName">
				<div class="reg-form-feedback" v-show="anyRegInputChanged">
					<ul class="feedback-items">
						<li :class="clsRegFirstNameValid"><span>Valid first name</span></li>
					</ul>
				</div>
				<input type="email" class="input-email form-control" autocomplete="reg-email" placeholder="Your Best Email" @keypress="regFormEmailChanged" @keyup.enter="registerIfRegEnabled" v-model="regForm.email">
				<div class="reg-form-feedback" v-show="anyRegInputChanged">
					<ul class="feedback-items">
						<li :class="clsRegEmailValid"><span>Valid email address</span></li>
					</ul>
				</div>
				<input type="password" class="input-password form-control" autocomplete="reg-password" placeholder="Password" @keypress="regFormPasswordChanged" @keyup.enter="registerIfRegEnabled" v-model="regForm.password">
				<div class="reg-form-feedback" v-show="anyRegInputChanged">
					<ul class="feedback-items">
						<li :class="clsRegPasswordLength"><span>At least twelve characters long</span></li>
						<li :class="clsRegPasswordLowerCase"><span>At least one lower case letter (a-z)</span></li>
						<li :class="clsRegPasswordUpperCase"><span>At least one upper case letter (A-Z)</span></li>
						<li :class="clsRegPasswordNumber"><span>At least one number (0-9)</span></li>
					</ul>
				</div>
				<div class="div-tos-agreement">
					<input type="checkbox" v-model="regForm.tosAgreement">
					<label>I agree to the <a href="/terms-of-service/" target="_blank" rel="nofollow">terms of service</a>.</label>
				</div>
				<button type="submit" class="btn btn-primary button-submit" :disabled="disableRegButton" @click="register">Create Account</button>
				<div class="cta-links">
					<span class="span-link login-link" @click="clickLoginLink">Already Have An Account?</span>
				</div>
				<div class="reg-form-submission-feedback" v-show="regSubmissionFeedbackNotNull">
					<span v-html="regForm.submissionFeedback"></span>
				</div>
			</div>
			<!-- reg form -->

		</div>
	</div>
</template>




<script>
	const MIN_PASSWORD_LEN = 12;
	const MAX_INPUT_LEN = 32;

	export default {
		mixins: [mixinAxios],
		data: () => ({
			showLoginForm: true,
			loginForm: {
				email: '',
				password: '',
				emailChanged: false,
				passwordChanged: false,
				submissionFeedback: null
			},
			regForm: {
				firstName: '',
				email: '',
				password: '',
				tosAgreement: true,
				firstNameChanged: false,
				emailChanged: false,
				passwordChanged: false,
				submissionFeedback: null
			}
		}),
		props: {
			urlRedirect : { type: String, default: null },
			showLogin   : { type: String, default: 'true' },
			width       : { type: Number, default: 300 }
		},
		created() {
			this.showLoginForm = (this.showLogin.toLowerCase() == 'true');
		},
		mounted() {
			this.setWidth();
		},
		methods: {

			/* common functions */
			setWidth() {
				this.signInFormContainer.style.width = common.parseWidthValue(this.width);
			},
			redirect(redirectUrl) {
				var redirectionNotNull = (this.redirectionUrl != null);

				if (redirectionNotNull) {
					window.location.href = this.redirectionUrl;
				} else {
					window.location.reload();
				}
			},
			firstNamePresent(firstName) {
				return (firstName.length > 0);
			},
			firstNameValidCharacters(firstName) {
				const regex = /^[\p{L}\p{Zs}\p{Cf}'\-‐’]+$/gu;
				return regex.test(firstName);
			},
			firstNameValid(firstName) {
				return this.firstNamePresent(firstName)
					&& this.firstNameValidCharacters(firstName);
			},
			emailValid(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(String(email).toLowerCase());
			},
			passwordLongEnough(password) {
				return (password.length >= MIN_PASSWORD_LEN);
			},
			passwordContainsLowerChar(password) {
				return (password.search(/[a-z]+/) !== -1);
			},
			passwordContainsUpperChar(password) {
				return (password.search(/[A-Z]+/) !== -1);
			},
			passwordContainsNumber(password) {
				return (password.search(/[0-9]+/) !== -1);
			},
			passwordValid(password) {
				return this.passwordLongEnough(password)
					&& this.passwordContainsLowerChar(password)
					&& this.passwordContainsUpperChar(password)
					&& this.passwordContainsNumber(password);
			},
			tosAgreementValid(tosAgreement) {
				return tosAgreement;
			},
			resetForms() {
				this.resetLoginForm();
				this.resetRegForm();
			},
			/* common functions */


			/* login form functions */
			clickRegisterLink() {
				this.resetForms();
				this.showLoginForm = false;
			},
			resetLoginForm() {
				this.loginForm.email              = '';
				this.loginForm.password           = '';
				this.loginForm.emailChanged       = false;
				this.loginForm.passwordChanged    = false;
				this.loginForm.submissionFeedback = null;
			},
			loginFormEmailChanged() {
				this.loginForm.emailChanged = true;
			},
			loginFormPasswordChanged() {
				this.loginForm.passwordChanged = true;
			},
			login() {
				this.setLoginSubmissionFeedback(null);

				this.resetRegForm(); // prevent chrome from remembering reg form input upon login

				return this.mixinAxios().post('/api/guest/Login/', this.loginDTO)
					.then((resLogin) => {
						if (resLogin.data.success) {
							this.redirect();
						} else {
							this.setLoginSubmissionFeedback(resLogin.data.message);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.then(() => {
						this.resetLoginChanges();
					});
			},
			loginIfLoginEnabled() {
				if (this.enableLoginButton) {
					this.login();
				}
			},
			setLoginSubmissionFeedback(msg) {
				this.loginForm.submissionFeedback = msg;
			},
			resetLoginChanges() {
				this.loginForm.emailChanged    = false;
				this.loginForm.passwordChanged = false;
			},
			/* login form functions */


			/* reg form functions */
			clickLoginLink() {
				this.resetForms();
				this.showLoginForm = true;
			},
			resetRegForm() {
				this.regForm.firstName          = '';
				this.regForm.email              = '';
				this.regForm.password           = '';
				this.regForm.tosAgreement       = true;
				this.regForm.firstNameChanged   = false;
				this.regForm.emailChanged       = false;
				this.regForm.passwordChanged    = false;
				this.regForm.submissionFeedback = null;
			},
			regFormFirstNameChanged() {
				this.regForm.firstNameChanged = true;
			},
			regFormEmailChanged() {
				this.regForm.emailChanged = true;
			},
			regFormPasswordChanged() {
				this.regForm.passwordChanged = true;
			},
			register() {
				this.setRegSubmissionFeedback(null);

				this.resetLoginForm(); // prevent chrome from remembering login form input upon registration

				return this.mixinAxios().post('/api/guest/register/', this.registrationDTO)
					.then((resRegister) => {
						if (resRegister.data.success) {
							this.redirect(resRegister.data.redirectUrl);
						} else {
							this.setRegSubmissionFeedback(resRegister.data.message);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.then(() => {
						this.resetRegChanges();
					});
			},
			registerIfRegEnabled() {
				if (this.enableRegButton) {
					this.register();
				}
			},
			setRegSubmissionFeedback(msg) {
				this.regForm.submissionFeedback = msg;
			},
			resetRegChanges() {
				this.regForm.firstNameChanged = false;
				this.regForm.emailChanged     = false;
				this.regForm.passwordChanged  = false;
			}
			/* reg form functions */

		},
		computed: {
			signInFormContainer() {
				return this.$refs['signInFormContainer'];
			},
			showRegistrationForm() {
				return !this.showLoginForm;
			},
			anyLoginInputChanged() {
				var anythingChanged = (this.loginForm.emailChanged || this.loginForm.passwordChanged);

				if (anythingChanged) {
					this.setLoginSubmissionFeedback(null);
				}

				return anythingChanged;
			},
			anyRegInputChanged() {
				var anythingChanged = (this.regForm.firstNameChanged || this.regForm.emailChanged || this.regForm.passwordChanged);

				if (anythingChanged) {
					this.setRegSubmissionFeedback(null);
				}

				return anythingChanged;
			},
			allLoginInputValid() {
				var email    = this.regForm.email;
				var password = this.regForm.password;

				var emailValid    = this.emailValid(email);
				var passwordValid = this.passwordValid(password);

				return (emailValid && passwordValid);
			},
			allRegInputValid() {
				var firstName    = this.regForm.firstName;
				var email        = this.regForm.email;
				var password     = this.regForm.password;
				var tosAgreement = this.regForm.tosAgreement;

				var firstNameValid    = this.firstNameValid(firstName);
				var emailValid        = this.emailValid(email);
				var passwordValid     = this.passwordValid(password);
				var tosAgreementValid = this.tosAgreementValid(tosAgreement);

				return (firstNameValid && emailValid && passwordValid && tosAgreementValid);
			},
			loginDTO() {
				return {
					contentBaseAccessInfo: {
						email    : this.loginForm.email,
						password : this.loginForm.password,
					},
					clientDateTime : common.getClientDateTimeString()
				};
			},
			registrationDTO() {
				return {
					contentBaseAccessInfo: {
						email     : this.regForm.email,
						password  : this.regForm.password,
						firstName : this.regForm.firstName,
						agreeToS  : this.regForm.tosAgreement,
					},
					clientDateTime : common.getClientDateTimeString()
				};
			},
			loginSubmissionFeedbackNotNull() {
				return (this.loginForm.submissionFeedback?.notNullOrWhitespace() ?? false);
			},
			regSubmissionFeedbackNotNull() {
				return (this.regForm.submissionFeedback?.notNullOrWhitespace() ?? false);
			},
			disableLoginButton() {
				return (this.requestActive);
			},
			enableLoginButton() {
				return (!this.disableLoginButton);
			},
			disableRegButton() {
				return (!this.allRegInputValid || this.requestActive);
			},
			enableRegButton() {
				return (!this.disableRegButton);
			},
			redirectionUrl() {
				var urlFromParam = common.getUrlParameterByName('redirect');

				return (urlFromParam != null)
					? urlFromParam
					: (this.urlRedirect != null)
					? this.urlRedirect
					: null;
			},
			clsRegFirstNameValid() {
				var firstNameValid = this.firstNameValid(this.regForm.firstName);

				return {
					'check-valid' : firstNameValid,
					'check-invalid' : !firstNameValid
				}
			},
			clsRegEmailValid() {
				var emailValid = this.emailValid(this.regForm.email);

				return {
					'check-valid' : emailValid,
					'check-invalid' : !emailValid
				}
			},
			clsRegPasswordLength() {
				var pwLongEnough = this.passwordLongEnough(this.regForm.password);

				return {
					'check-valid' : pwLongEnough,
					'check-invalid' : !pwLongEnough
				}
			},
			clsRegPasswordLowerCase() {
				var pwContainsLowerChar = this.passwordContainsLowerChar(this.regForm.password);

				return {
					'check-valid' : pwContainsLowerChar,
					'check-invalid' : !pwContainsLowerChar
				}
			},
			clsRegPasswordUpperCase() {
				var pwContainsUpperChar = this.passwordContainsUpperChar(this.regForm.password);

				return {
					'check-valid' : pwContainsUpperChar,
					'check-invalid' : !pwContainsUpperChar
				}
			},
			clsRegPasswordNumber() {
				var pwContainsNumber = this.passwordContainsNumber(this.regForm.password);

				return {
					'check-valid' : pwContainsNumber,
					'check-invalid' : !pwContainsNumber
				}
			}
		},
		watch: {
			width(newVal, oldVal) {
				this.setWidth();
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	.sign-in-form-container {
		min-width: 250px;
		padding: 0;
	}

	.login-form, .registration-form {
		border:0px solid lightgray;
		border-radius:0.25rem;
	}

	.login-form .input-email {
		margin-top:0px;
	}

	.registration-form .input-first-name {
		margin-top:0px;
	}

	.input-first-name, .input-email, .input-password {
		margin-top:10px;
	}

	input[type="email"],
	input[type="password"],
	input[type="text"] {
		&:focus {
			box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
			border: 1px solid rgb(206, 212, 218);
		}
	}

	.div-tos-agreement {
		margin-top:10px;
		display:flex;
		align-items:center;
		justify-content:center;
	}

	.div-tos-agreement input {
		cursor:pointer;
	}

	.div-tos-agreement label {
		margin:0px 0px 0px 10px;
	}

	.button-submit {
		padding:5px 15px;
		font-size:1.2em;
		display:inline-block;
		width:100%;
		min-width:100%;
		max-width:100%;
		border-radius:0.25rem;
		margin:10px 0px 0px 0px;
	}

	.cta-links {
		margin-top:10px;
	}

	.reg-link {
		float:left;
		cursor:pointer;
	}

	.pw-link {
		float:right;
	}

	.login-link {
		display:block;
		text-align:center;
		cursor:pointer;
	}

	.reg-form-submission-feedback {
		margin-top:10px;
	}

	.reg-form-feedback {
		margin-top:10px;
	}

	.login-form-submission-feedback {
		margin-top:10px;
	}

	.feedback-items {
		margin:0px;
		padding-left:25px;
	}

	.feedback-items li span {
		position:relative;
		top:-2px;
		font-size:15px;
		color:#666666;
	}

	.check-valid {
		list-style-image: url(/img/icons/valid-15.png)
	}

	.check-invalid {
		list-style-image: url(/img/icons/invalid-15.png)
	}

</style>